import { Card, Checkbox, Col, Divider, Menu, Modal, Pagination, Radio, Row, Select, Spin,  } from 'antd';
import Title from 'antd/es/typography/Title';
import React, { useEffect, useRef, useState } from 'react';
import "./formulaires.css";
import TextType from '../../components/reponseTypes/TextType';
import ImageType from '../../components/reponseTypes/ImageType';
import DateType from '../../components/reponseTypes/DateType';
import HeureType from '../../components/reponseTypes/HeureType';
import RadioType from '../../components/reponseTypes/RadioType';
import CheckboxType from '../../components/reponseTypes/CheckboxType';
import { useDispatch, useSelector } from 'react-redux';
import { fetchResponsesGroupedByQuestion } from '../../redux/actions/ResponsesGroupedByQuestionActions';
import DateView from '../../components/reponseTypes/DateView';
import HeureView from '../../components/reponseTypes/HeureView';
import { DeleteOutlined, LoadingOutlined, PrinterOutlined } from '@ant-design/icons';
import { listReponses } from '../../redux/actions/ListReponsesActions';
import { getFormById } from '../../redux/actions/GetFormFromIdActions';
import ChoixMultiples from '../../components/questionTypes/ChoixMultiples';
import Checkboxes from '../../components/questionTypes/Checkboxes';
import SelectListeDeroulant from '../../components/questionTypes/SelectListeDeroulant';
import TextArea from 'antd/es/input/TextArea';
import sheet from '../../assets/img/sheet.png';
import { DeletResponseFormActions } from '../../redux/actions/DeletResponseFormActions';
import { ListFormsActions } from '../../redux/actions/ListFormsActions';
import html2canvas from 'html2canvas';


     const itemsMenuResponses = [
        { key: '1', label: 'Résumé', },
        { key: '2', label: 'Question', },
        { key: '3', label: 'Individuel', },
      ];

       const ReponsesViewForm = ({ donneeFormulaire }) => {
  const [activeKey, setActiveKey] = useState('1');
  const dispatch = useDispatch();
  const formId = donneeFormulaire.id;
    const [openModalConfirmation, setOpenModalConfirmation] = useState();

  const handleOpenModalConfirmation = () => {
        setOpenModalConfirmation(true);
  };

  const handleCancelConfirmation = () => {
        setOpenModalConfirmation(false);
  };

  const {  form: formById, } = useSelector((state) => state.getFormById);
  
     useEffect(() => {
      if (formId) {
        dispatch(getFormById(formId));
      }
    }, [dispatch,formId]);

  useEffect(() => {
    dispatch(fetchResponsesGroupedByQuestion(formId));
  }, [dispatch, formId]);

  const { loading: loadingGroupedResponses, groupedResponses,  } = useSelector(state => state.responsesGroupedByQuestion);
  const donneeQuestion = groupedResponses?.data || [];
  // console.log(groupedResponses);

  const renderResponseByType = (item, answer, onReady) => {
    switch (item?.field?.type) {
      case 'text':
      case 'textarea':
      case 'email':
      case 'number':
        return <TextType variant="filled" value={answer?.value} />;
      case 'radio':
      case 'select':
        return <RadioType answers={item?.answers} options={item?.field?.options || []} onReady={(plot) => {
    chartRefs.current[item?.field?.id] = plot;
  }} />;
      case 'checkbox':
        return <CheckboxType answers={item?.answers} options={item?.field?.options || []} onReady={onReady} />;
      case 'file':
        return <ImageType imageSrc={answer?.value} />;
      case 'date':
        return <DateType value={answer?.value} />;
      case 'time':
        return <HeureType value={answer?.value} />;
      default:
        return null;
    }
  };
   
  const [selectedId, setSelectedId] = useState(undefined);
  const [selectLabelQuestion, setSelectLabelQuestion] = useState('');

  const options = donneeQuestion.map((item) => ({
    value: item?.field?.id,
    label: item?.field?.label,
    
  }));

const handleSelect = (value, option) => {
  setSelectedId(value);
  setSelectLabelQuestion(option.label); 
};

  const selectedQuestion = donneeQuestion.find(
    (item) => item.field.id === selectedId
  );

useEffect(() => {
  if (donneeQuestion.length > 0) {
    const firstQuestion = donneeQuestion[0];
    setSelectedId(firstQuestion.field.id);
    setSelectLabelQuestion(firstQuestion.field.label);
  } else {
    setSelectedId(undefined);
    setSelectLabelQuestion('');
  }
}, [donneeQuestion]);

useEffect(() => {
    dispatch(listReponses(formId));
  }, [dispatch, formId]);

  const {loading:loadingListeReponses, responses:dataResponsesByFormId, } = useSelector(state => state.listReponses)
  
  const handleDeletResponseForm = async () => {
   await dispatch(DeletResponseFormActions(reponseId));
   await dispatch(listReponses(formId));
   await dispatch(getFormById(formId));
   await dispatch(fetchResponsesGroupedByQuestion(formId));
   await dispatch(ListFormsActions());
   handleCancelConfirmation();
  };
    const sectionToPrintRef = useRef(null);

const handlePrint = () => {
  const printContent = sectionToPrintRef.current;
  if (!printContent) return;

  const printWindow = window.open('', '_blank', 'width=800,height=600');
  if (!printWindow) {
    alert("Popup bloquée. Veuillez autoriser les popups pour ce site.");
    return;
  }

  const cloned = printContent.cloneNode(true);
  const syncValues = (source, target) => {
    const sourceInputs = source.querySelectorAll('input, textarea, select');
    const targetInputs = target.querySelectorAll('input, textarea, select');
    sourceInputs.forEach((srcEl, i) => {
      const tgtEl = targetInputs[i];
      if (!tgtEl) return;
      if (srcEl.type === 'radio' || srcEl.type === 'checkbox') {
        tgtEl.checked = srcEl.checked;
      } else if (srcEl.tagName === 'SELECT') {
        tgtEl.selectedIndex = srcEl.selectedIndex;
      } else {
        tgtEl.value = srcEl.value;
      }
    });
  };

  syncValues(printContent, cloned);

  const styles = Array.from(document.styleSheets)
    .map((styleSheet) => {
      try {
        return styleSheet.ownerNode.outerHTML;
      } catch (e) {
        return '';
      }
    })
    .join('');

  printWindow.document.write(`
    <html>
      <head>
        <title>Impression</title>
        ${styles}
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }
          .stylCardTitleDesc {
            border-top: 10px solid #43CE0C;
            transition: border-color 0.3s ease, box-shadow 0.3s ease;
            font-family: 'Roboto', Helvetica, Arial, sans-serif;
            margin-bottom: 15px;
          }
          .card-to-printI {
            margin-bottom: 15px !important;
          }
             input[type="radio"],
          input[type="checkbox"] {
            width: 16px;
            height: 16px;
            border: 2px solid #333;
            border-radius: 50%;
            display: inline-block;
            position: relative;
            margin-right: 5px;
          }
          input[type="radio"]:checked::before {
           content: "✓";
            color: black;
            font-size: 14px;
            position: absolute;
            top: -2px;
            left: 2px;
          }
        </style>
      </head>
      <body></body>
    </html>
  `);
  printWindow.document.close();
  printWindow.onload = () => {
    printWindow.document.body.appendChild(cloned);
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }, 300);
  };
};

const printRef = useRef(null);
const handlePrintR = () => {
  const element = printRef.current;

  if (!element) {
    // console.error("Élément à imprimer introuvable.");
    return;
  }

  html2canvas(element, {
    useCORS: true,
    scale: 2,
  }).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");

    const printWindow = window.open("", "", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Résumé des réponses</title>
          <style>
            body { margin: 0; }
            img { width: 90%; }
          </style>
        </head>
        <body>
          <img src="${imgData}" onload="window.print(); window.onafterprint = function() { window.close(); }" />
        </body>
      </html>
    `);
    printWindow.document.close();
  }).catch((err) => {
    // console.error("Erreur lors de la capture :", err);
  });
};


const chartRefs = useRef({}); 
 

const renderResponseByType2 = (item, answer) => {
  switch (item?.field?.type) {
    case 'text':
    case 'textarea':
    case 'email':
    case 'number':
      return <TextType variant="borderless" value={answer?.value} />;
    case 'radio':
      return <div><Radio checked /><span style={{color:"#5F6368", marginLeft:"1.2%"}}>{answer}</span></div>;
    case 'select':
  let valueParsed = '';
  if (answer) {
    try {
      const parsed = JSON.parse(answer);
      valueParsed = Array.isArray(parsed) ? parsed.join(', ') : parsed;
    } catch (e) {
      valueParsed = answer;
    }
  }
  return <div>{valueParsed}</div>;
    case 'checkbox':
        return <div><Checkbox checked />  <span style={{color:"#5F6368", marginLeft:"1.2%"}}>{answer}</span></div>;
    case 'file':
      return <ImageType imageSrc={answer?.value} />;
    case 'date':
      return <DateView value={answer?.value} />;
    case 'time':
      return <HeureView value={answer?.value} />;
    default:
      return null;
  }
};

const renderResponseByType3 = (answers) => {
  switch (answers?.Field?.type) {
    case 'text': 
        return <div><TextType variant="underlined" style={{fontSize:15}} value={answers?.value} /></div>;
    case 'textarea':
        return <TextArea style={{color:"#000"}} maxLength={6} rows={2} value={answers?.value} />;
    case 'email':
    case 'number':
        return <p style={{fontSize:15}}>{answers?.value}</p>;   
    case 'radio':
        return <div style={{marginBottom:-35}}> <ChoixMultiples editable={false} options={answers?.Field?.options}  value={answers?.value} disabled={true}  /></div>;
    case 'select':
      let parsedV = '';
      if (answers?.value) {
        try {
          const parsed = JSON.parse(answers?.value);
          parsedV = Array.isArray(parsed) ? parsed.join(', ') : parsed;
        } catch (e) {
          parsedV = answers?.value;
        }
      }
        return <div style={{width:"60%"}}><SelectListeDeroulant options={answers?.Field?.options}  value={parsedV} disabled={false} /></div>;
    case 'checkbox':
        return <div style={{marginBottom:-35}}><Checkboxes editable={false} options={answers?.Field?.options}  value={answers?.value}  disabled={true} /></div>;
    case 'file':
      return <ImageType imageSrc={answers?.value} />;
    case 'date':
      return <DateView value={answers?.value} />;
    case 'time':
      return <HeureView value={answers?.value} />;
    default:
      return null;
  }
};

const [page, setPage] = useState(1);
const pageSize =1;


const [reponseId, setReponseId] = useState('');


useEffect(() => {
  if (dataResponsesByFormId?.data?.length > 0) {
    const firstPageData = dataResponsesByFormId?.data[0];
    if (firstPageData && firstPageData?.Answers.length > 0) {
      setReponseId(firstPageData?.Answers[0]?.responseId);
    }
  }
}, [dataResponsesByFormId]);


const handlePageChange = (newPage) => {
  setPage(newPage);
  const data = dataResponsesByFormId?.data[newPage - 1];
  if (data) {
    setReponseId(data?.Answers[0]?.responseId);
  }
};

// console.log(reponseId);

  const renderContent = () => {
    switch (activeKey) { 
      case '1':
        return (
          <>
            <Card style={{ marginBottom: "20px", marginTop: "-28.1px", boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)" }}>
              <PrinterOutlined onClick={handlePrintR} style={{ fontSize: 18 }} />
            </Card>

          <div className="print-section" ref={printRef}>
        {donneeQuestion.map((item) => (
          <Card key={item?.field?.id} style={{ marginBottom: 20 }}>
            <p><strong>{item?.count}</strong> réponses</p>
            <div><strong>{item?.field?.label}</strong></div>
            <div style={{ marginTop: 10 }}>
              {['radio', 'checkbox', 'select'].includes(item?.field?.type) ? (
                renderResponseByType(item, null, (plot) => {
                  chartRefs.current[item?.field?.id] = plot;
                })
              ) : (
                item?.answers.map((answer, idx) => (
                  <div style={{ marginBottom: 20 }} key={idx}>{renderResponseByType(item, answer)}</div>
                ))
              )}
            </div>
          </Card>
        ))}
          </div>
          </>
        );
 
      case '2':
        return (
          <div style={{fontFamily:" Roboto, Arial, sans-serif"}}>
            <Card style={{ marginBottom: 20 , marginTop:-28.1, boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)"}}>
              <Row justify="space-between" align="middle">
                <Col>
                  <Select
                    style={{ width: 300, height:50 }}
                    options={options}
                    onChange={handleSelect}
                    value={selectedId}
                  />
                </Col>
                <Col style={{width:350}}>
                  <Pagination
                    current={donneeQuestion.findIndex(q => q?.field?.id === selectedId) + 1}
                    total={donneeQuestion.length}
                    pageSize={1}
                    onChange={(page) => {
                      const newSelected = donneeQuestion[page - 1];
                      if (newSelected) {
                        setSelectedId(newSelected?.field?.id);
                      }
                    }}
                    showSizeChanger={false}
                  />
                </Col>
              </Row>
            </Card>

            {selectedQuestion && (
              <>
                <Card style={{ marginBottom: 20, boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)" }}>
                  <div style={{fontSize:17}}>{selectedQuestion?.field?.label}</div>
                </Card>
                  {['select','radio', 'checkbox'].includes(selectedQuestion?.field?.type) ? (
                    <>
                      {(selectedQuestion?.field?.options || []).map((option, idx) => {
                        const count = selectedQuestion?.answers.reduce((acc, ans) => {
                          let parsedValue;
                          try {
                            parsedValue = JSON.parse(ans.value);
                          } catch {
                            parsedValue = ans.value;
                          }
                          if (Array.isArray(parsedValue)) {
                            return parsedValue.includes(option) ? acc + 1 : acc;
                          } else {
                            return parsedValue === option ? acc + 1 : acc;
                          }
                        }, 0);
                        if (count === 0) return null;
                        return (
                          <Card key={idx} style={{ marginBottom: 20, boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)" }}>
                            {renderResponseByType2(selectedQuestion, option)}
                            <Divider />
                            <p style={{ color: 'blue' }}>
                              <strong>{count}</strong> réponse{count > 1 ? 's' : ''}
                            </p>
                          </Card>
                        );
                      })}
                    </>
                  ) : (
                    <>
                      {selectedQuestion?.answers.map((answer, idx) => (
                        <Card key={idx} style={{ marginBottom: 20, boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)" }}>
                          {renderResponseByType2(selectedQuestion, answer)}
                          <Divider />
                          <p style={{ color: 'blue' }}><strong>1</strong> réponse</p>
                        </Card>
                            ))}
                          </>
                            )}
                        </>
                      )}
                    </div>
                  );

                  case '3':
                    return (
                    <div>
                    <Card style={{marginTop:-28.2, marginBottom:20, boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)"}}>
                      <Row gutter={65}>
                          <Col span={20}>
                            <Pagination simple={{ readOnly: true }} current={page} pageSize={pageSize} total={dataResponsesByFormId?.data?.length} onChange={handlePageChange} />
                          </Col>
                          <Col span={4} style={{fontSize:18,}}>
                            <PrinterOutlined onClick={handlePrint} style={{ cursor: 'pointer' }} />
                            <DeleteOutlined onClick={handleOpenModalConfirmation} style={{ cursor: 'pointer', marginLeft:20, color:"#FF0000" }}  />
                          </Col>
                        </Row>
                      </Card>

                      <>
                        
                        {/* {dataResponsesByFormId?.data?.length > 0 && */}
                          {/* // dataResponsesByFormId.data[0]?.Answers?.length > 0 && ( */}
                            <Row>
                              <Col span={24}>
                                <Card
                                  className="stylCardTitleDesc"
                                  style={{ boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)" }}
                                >
                                  <p style={{ marginTop: -10 }}>
                                    Les réponses ne peuvent pas être modifiées.
                                  </p>
                                  <h1>{formById?.form?.title || "Formulaire sans titre"}</h1>
                                  <h3 style={{ marginBottom: -10 }}>
                                    {formById?.form?.description || "Description du formulaire"}
                                  </h3>
                                </Card>
                              </Col>
                            </Row>
                        {/* // )} */}


                        {[dataResponsesByFormId?.data[page - 1]].map((data, index) => (
                          
                          
                          <div key={index} >
                              
                            {data?.Answers.map((answers, keyanswer) => (
                              <>
                           
                              <Card style={{boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)"}}
                                key={keyanswer}
                                className="card-to-print" >
                                <p style={{ fontSize: 16, fontWeight: 500, marginTop:-5 }}> {answers?.Field?.label}</p>
                                <p style={{marginBottom:-15}}>{renderResponseByType3(answers)}</p>
                              </Card>
                              </>
                            ))}
                          </div>
                        ))}
                      </>

                      <div style={{display:'none'}} >
                      <div ref={sectionToPrintRef} >
                        <Row>
                            <Col span={24}>
                              <Card className="stylCardTitleDesc">
                                <p style={{marginTop:-10}}>Les réponses ne peuvent pas être modifiées.</p>
                                  <h1>
                                    {formById?.form?.title || 'Formulaire sans titre'}
                                  </h1>
                                  <h3 style={{marginBottom:-10}}>
                                    {formById?.form?.description || 'Description du formulaire'}
                                  </h3>
                              </Card>
                            </Col>
                          </Row>

                        {[dataResponsesByFormId?.data[page - 1]].map((data, index) => (
                          <div key={index} >
                            {data?.Answers.map((answers, keyanswer) => (
                              <Card
                                key={keyanswer}
                                className="card-to-printI" >
                                <p style={{ fontSize: 16, fontWeight: 500, marginTop:-5 }}>
                                  {answers?.Field?.label}
                                </p>
                                <p style={{marginBottom:-15}}>{renderResponseByType3(answers)}</p>
                              </Card>
                            ))}
                          </div>
                        ))}
                      </div>
                      </div>
                    </div>);
                    
                  default:
                    return null;
                }
              };


 const redirectSheet = () => {
  const url = `${window.location.origin}/sheet/${formId}`;
  window.open(url, "_blank");
};
const customSpinIndicator = <LoadingOutlined  style={{ fontSize: 75, color: '#43CE0C' }} spin />;

  return (
    <div className='stylDivGlobl'>
      <Row justify="center">
        <Col span={20}>
          <Card className='stylCardReponse'>
           <Row gutter={6}>
              <Col span={12}>
                <Title level={3} style={{ marginTop: -8, marginBottom: 16 }}>
                  {dataResponsesByFormId?.data?.length} réponses
                </Title>
              </Col>
              <Col span={12} style={{ textAlign: 'right' }}>
                <div onClick={redirectSheet} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "10px" }}>
                  <img src={sheet} width={20} height={20} alt="sheet icon" />
                  <p style={{ margin: 0, cursor: "pointer",color:"#43CE0C",fontWeight:"700px" }}>Afficher dans excel</p>
                </div>
              </Col>
            </Row>
            {(loadingGroupedResponses && loadingListeReponses) ? (
                        <Spin  indicator={customSpinIndicator}  style={{ position: 'absolute',  top: '50%', left: '45%', transform: 'translate(-50%, -50%)' }} 
                        />
                    ) : ( <Menu
              className='stylMenuGlobal'
              selectedKeys={[activeKey]}
              onClick={(e) => setActiveKey(e.key)}
              mode="horizontal"
              items={itemsMenuResponses}
              style={{ borderBottom: "none" }}
            />)}
          </Card>
        </Col>
        <Col span={20}>
          <div className='stylDivRenderC'>
            {renderContent()}
          </div>
        </Col>
      </Row>

        {/* LES MODALS */}
          <Modal
              maskClosable={false}
              closable={false}
              title="Suppression de réponses d'un formulaire" 
              open={openModalConfirmation} 
              onOk={handleDeletResponseForm}       
              onCancel={handleCancelConfirmation}
              okText="Oui" 
              cancelText="Non" okButtonProps={{ style: { backgroundColor: '#42C90E', borderColor: '#42C90E', color: 'white' } }} >
              <p>Voulez-vous vous supprimer cette réponse?</p>
           </Modal> 

    </div>
  );
};

export default ReponsesViewForm;
